<template>
    <div>
        <Cabecalho :logo="atendimento.logoCliente" :nomeAssistencia="atendimento.assistencia" />

        <DadosSolicitante 
            :nomeSolicitante="atendimento.solicitante" 
            :protocolo="atendimento.protocolo"        
            :data="atendimento.dataAtendimento" 
            :motivo="atendimento.motivo" 
            :servicos="atendimento.servicos"
            :placa="atendimento.placa" 
            :modelo="atendimento.modelo" 
            :montadora="atendimento.montadora" 
        />
        <div class="row mt-4">
            <div class="col-12" v-show="totalServicos > 1">
                <ul class="nav nav-tabs">
                    <li class="nav-item"
                        v-for="(servico, idServicoAtendimento) in atendimento.servicos" :key="idServicoAtendimento"
                        @click="selecionarServico(idServicoAtendimento)"
                    >
                        <a role="button" class="nav-link" :class="{ active: idServicoAtendimento === idServicoAtendimentoSelecionado }">
                            {{ servico.descricao || '' }}
                        </a>
                    </li>
                </ul>
            </div>
            <HistoricoAtendimento 
                :exibirRastreioPrestadores="atendimento.exibirRastreioPrestadores" 
                :status="statusAtual"    
                :horaStatus="horaStatusAtual" 
                :enderecoOrigem="atendimento.enderecoOrigem"
                :enderecoDestino="atendimento.enderecoDestino" 
                :idServicoAtendimento="idServicoAtendimentoSelecionado" 
            />
        </div>

        <div class="row mt-4 mb-5" v-if="temAnexos">
            <div class="col-12">
                <ListaAnexos :anexos="atendimento.anexos" />
            </div>
        </div>

        <div class="row mt-3 mb-3">
            <div class="col-12">
                <Ajuda />
            </div>
        </div>
    </div>
</template>

<script setup>
import Cabecalho from "@/components/Cabecalho.vue";
import DadosSolicitante from "@/components/DadosSolicitante.vue";
import HistoricoAtendimento from "@/components/HistoricoAtendimento.vue";
import ListaAnexos from "@/components/ListaAnexos.vue";
import Ajuda from "@/components/Ajuda.vue";

import { storeToRefs } from 'pinia';
import { useAtendimentoStore } from '@/stores/atendimento';
import { ref, computed, watch } from "vue";

const store = useAtendimentoStore();
const { atendimento, totalServicos, temAnexos } = storeToRefs(store);
let servicoAtendimento = ref(null);
let idServicoAtendimento = ref(null);
let status = ref(null);
let horaStatus = ref(null);

const statusAtual = computed(() =>  status.value);
const horaStatusAtual = computed(() =>  horaStatus.value);
const idServicoAtendimentoSelecionado = computed(() => idServicoAtendimento.value || '');

function selecionarServico(id) {
    idServicoAtendimento.value = id;
    servicoAtendimento.value = atendimento.value.servicos[id];
    status.value = servicoAtendimento.value.status;
    horaStatus.value = servicoAtendimento.value.horaStatus;
}

function montarDadosHistorico() {
    if (!status.value && !horaStatus.value && atendimento.value) {
        status.value = atendimento.value.status;
        horaStatus.value = atendimento.value.horaStatus;
        if (totalServicos.value > 0) {
            idServicoAtendimento.value = Object.keys(atendimento.value.servicos)[0];
            status.value = atendimento.value.servicos[idServicoAtendimento.value].status;
            horaStatus.value = atendimento.value.servicos[idServicoAtendimento.value].horaStatus;
            selecionarServico(idServicoAtendimento.value);
        }
    }
}

watch(() => {    
    montarDadosHistorico();
});

</script>
